import { UserMinus } from "lucide-react";
import {
  BaseAppointmentAction,
  AppointmentActionCategory,
  UserRole,
  AppointmentActionContext,
  AppointmentActionPayload,
  AppointmentActionResult,
} from "../core/base-action";
import { appointment_status } from "@/models/appointment.model";
import { fieldActionMessage } from "@/lib/appointment-field-actions";
import { activeOrganization } from "@/repositories/appointments.repository";
import { appointmentFieldActions } from "@/services/appointment-field-actions.service";

const reasonGiven = (payload?: AppointmentActionPayload): string => (typeof payload?.reason === "string" ? payload.reason.trim() : "");

const NO_REASON = "Give a reason for the reassignment";

export class RequestReassignmentAction extends BaseAppointmentAction {
  readonly config = {
    id: "request_reassignment",
    label: "Request Reassignment",
    description: "Hand this appointment back and ask the vendor to reassign it",
    icon: UserMinus,
    category: AppointmentActionCategory.REQUEST,
    permissions: {
      requiredRole: [UserRole.SUBS],
      requiredStatuses: [appointment_status.pending, appointment_status.assigned, appointment_status.rescheduled],
    },
    requiresDialog: true,
    variant: "default" as const,
  };

  validatePayload(payload?: AppointmentActionPayload): string | null {
    return reasonGiven(payload) ? null : NO_REASON;
  }

  getDialogComponent(): string {
    return "RequestReassignmentDialog";
  }

  async execute(context: AppointmentActionContext, payload?: AppointmentActionPayload): Promise<AppointmentActionResult> {
    const reason = reasonGiven(payload);
    if (!reason) return { success: false, message: NO_REASON };
    try {
      await appointmentFieldActions.handBack(context.appointmentId, reason, activeOrganization());
      return { success: true, message: "Reassignment request sent successfully" };
    } catch (error) {
      return { success: false, message: fieldActionMessage(error, "Failed to send reassignment request") };
    }
  }
}
